import $ from "jquery";

$(() => {
    $("[data-bookmark]").on("click", function (e: JQuery.Event) {
        e.stopPropagation();
        e.preventDefault();

        const $element = $(this);

        const bookmarkId = $element.attr("data-bookmark-id") as string;
        const itemType = $element.attr("data-bookmark-item-type") as string;
        const itemId = Number($element.attr("data-bookmark-item-id") as string);

        if (bookmarkId) {
            $.ajax({
                url: "/api/bookmarks/delete",
                type: "POST",
                data: { bookmarkId },
                success: () => {
                    $element.attr("data-bookmark-id", "");
                }
            }).catch((err) => {
                console.error(err);
            });
        } else {
            $.ajax({
                url: "/api/bookmarks/save",
                type: "POST",
                data: {
                    itemType,
                    itemId
                },
                success: (response: number) => {
                    console.log(response);
                    $element.attr("data-bookmark-id", response);
                }
            }).catch((err) => {
                console.error(err);
            });
        }
    });
});
